// import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import App from "./App.tsx";
import "./index.css";
import { apolloClient } from "./lib/apollo.ts";
import { ToastHost } from "./components/Common/ToastHost/ToastHost.tsx";

const root = ReactDOM.createRoot(document.getElementById("root")!);
const renderApp = () => {
	root.render(
		// <React.StrictMode>
			<ApolloProvider client={apolloClient}>
				<ToastHost />
				<App />
			</ApolloProvider>
		// </React.StrictMode>
	);
};
renderApp();
